function Welcome() {
  return (
    <div className="welcome">
        <p>
            <span className="welcome-title">Hello, I'm</span> <span className='welcome-name'>Tyler</span> 
        </p>
        <p className="welcome-subtitle">
          Junior Software Engineer | Embedded Linux & Firmware
        </p>
    </div>
  );
}

export default Welcome;
